import * as Yup from 'yup';
import { Param } from '../../../../../../shared/types/param';

export const initialValues: Param = {
    name: '',
    active: true,
    code: '',
    class: '',
    extra2: '',
    parent: '',
};

export const validationSchema = (id: string) =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        parent: Yup.string().required('El tipo de PQR es obligatorio'),
        extra2: id
            ? Yup.string().required('El descripción es obligatoria')
            : Yup.string().notRequired(),
    });
